import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { TextBlock } from '../../models/text-block';
import { TranslateService } from '@ngx-translate/core';
import { CompanyInfoStateService } from '../../../contact/services/company-info-state.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-text-block',
  templateUrl: './text-block.component.html',
  styleUrls: ['./text-block.component.css']
})
export class TextBlockComponent implements OnInit, OnDestroy {

  @Input()
  prefix: string;

  @Input()
  index = 1;

  private companyInfoSubscription: Subscription

  constructor(
    private translateService: TranslateService,
    private companyInfoStateService: CompanyInfoStateService,
  ) { }

  ngOnInit() {
    this.companyInfoSubscription = this.companyInfoStateService.initialize().subscribe();
  }

  ngOnDestroy(): void {
    if (this.companyInfoSubscription) {
      this.companyInfoSubscription.unsubscribe();
      this.companyInfoSubscription = null;
    }
  }

  get companyName(): string {
    return this.companyInfoStateService.companyInfo ? this.companyInfoStateService.companyInfo.name : '';
  }

  get companyPhone(): string {
    return this.companyInfoStateService.companyInfo ? this.companyInfoStateService.companyInfo.phone : '';
  }

  get companyEmail(): string {
    return this.companyInfoStateService.companyInfo ? this.companyInfoStateService.companyInfo.email : '';
  }

  get companyRegistry(): string {
    return this.companyInfoStateService.companyInfo ? this.companyInfoStateService.companyInfo.registry : '';
  }

  get companyVat(): string {
    return this.companyInfoStateService.companyInfo ? this.companyInfoStateService.companyInfo.vat : '';
  }

  get companyStreet(): string {
    return this.companyInfoStateService.companyInfo ? this.companyInfoStateService.companyInfo.street : '';
  }

  get companyCity(): string {
    return this.companyInfoStateService.companyInfo ? this.companyInfoStateService.companyInfo.city : '';
  }

  get companyZip(): string {
    return this.companyInfoStateService.companyInfo ? this.companyInfoStateService.companyInfo.zip + '' : '';
  }

  get companyWebsite(): string {
    return this.companyInfoStateService.companyInfo ? this.companyInfoStateService.companyInfo.website : '';
  }

  get textFields(): object {
    return {
      companyName: this.companyName,
      companyPhone: this.companyPhone,
      companyEmail: this.companyEmail,
      companyStreet: this.companyStreet,
      companyZip: this.companyZip,
      companyCity: this.companyCity,
      companyWebsite: this.companyWebsite,
      companyVat: this.companyVat,
      companyRegistry: this.companyRegistry
    };
  }

  get textBlocks(): TextBlock[] {
    const result = new Array<TextBlock>();
    const textFields = this.textFields;
    for (let index = this.index; index < 1000; index++) {
      const headerValue = this.getTranslateValue(`${this.prefix}_H${index}`);
      const textValue = this.getTranslateValue(`${this.prefix}_T${index}`, textFields);
      const paragraphs = new Array<string>();
      for (let paragraphIndex = 1; paragraphIndex < 1000; paragraphIndex++) {
        const paragraphValue = this.getTranslateValue(`${this.prefix}_P${index}_${paragraphIndex}`, textFields);
        if (paragraphValue) {
          paragraphs.push(paragraphValue);
        } else {
          break;
        }
      }

      if (headerValue || textValue || paragraphs.length) {
        result.push(new TextBlock(headerValue, textValue, paragraphs));
      } else {
        break;
      }
    }
    return result;
  }

  getTranslateValue(key: string, data?: any): string {
    const value = this.translateService.instant(key, data);
    return value === key ? '' : value;
  }

}
